module.exports = __webpack_public_path__ + "img/4.5e8d6447.svg";